"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _lodash = require("lodash");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('underscore'),
  extend = _require.extend,
  findWhere = _require.findWhere,
  flatten = _require.flatten,
  isArray = _require.isArray,
  isEmpty = _require.isEmpty,
  isObject = _require.isObject,
  isString = _require.isString,
  last = _require.last,
  partial = _require.partial,
  sortBy = _require.sortBy,
  object = _require.object;
var hasIconCorrectFormat = function hasIconCorrectFormat(icon) {
  return /file\.(png|jpeg|jpg|gif)$/i.test(icon);
};
angular.module('backstage.directives.externals').directive('bsDefaultExternalComboWidget', ['$rootScope', function ($rootScope) {
  return {
    templateUrl: '/static/partials/components/default-external-combo-widget.html',
    require: '?ngModel',
    priority: 100,
    scope: {
      model: '=ngModel',
      fieldDescriptor: '=',
      field: '=',
      label: '=',
      hideLabel: '=',
      hideCreateButton: '=',
      disableOptionsRemove: '=',
      options: '=',
      showAddButtonInHeader: '=',
      isBulkEdit: '=',
      bulkFieldOptions: '='
    },
    link: function link(scope, elem, attr, ctrl) {
      ctrl.$validators.required = function (modelValue, viewValue) {
        var isRequired = ((scope.fieldDescriptor || {}).validations || {}).required;
        return !(isRequired && ctrl.$touched && ctrl.$isEmpty(viewValue[scope.fieldDescriptor.field]));
      };
      scope.$watch('model[fieldDescriptor.field]', function (newValue, oldValue) {
        if (newValue !== undefined && oldValue !== newValue) {
          if (scope.modelCleaned) {
            $rootScope.setNavigationWarningMessage(null);
            scope.modelCleaned = false;
          } else {
            ctrl.$setTouched();
            ctrl.$validate();
          }
        }
      });
      var fieldValues = scope.model[scope.field];
      if (!fieldValues) {
        return;
      }
      if (!isArray(fieldValues)) {
        fieldValues = [fieldValues];
      }
      if (scope.type === 'icon' && scope.idField === 'fp_asset') {
        fieldValues = fieldValues.map(function (id) {
          return hasIconCorrectFormat(id) ? id : "".concat(id, "/file.png");
        });
      }
      scope.backlinksService.queryBacklinksWithKeys(scope.eventId, scope.type, scope.idField, fieldValues).then(function (list) {
        var fieldId = (0, _lodash.get)(scope.options, 'id_field') || 'fp_ext_id';
        if (isArray(scope.model[scope.field])) {
          var prevCount = scope.model[scope.field].length;
          var backlinksLookup = object(list.filter(function (doc) {
            return doc;
          }).map(function (doc) {
            return [doc[scope.idField], doc[fieldId]];
          }));
          scope.model[scope.field] = scope.model[scope.field].map(function (val) {
            return backlinksLookup[val] || val;
          });
          if (prevCount !== scope.model[scope.field].length) {
            scope.modelCleaned = true;
          }
        }
        if (scope.single_doc) {
          var prevValue = scope.model[scope.field];
          if (list.length && list[0]) {
            scope.model[scope.field] = list[0][fieldId];
          }
          if (prevValue !== scope.model[scope.field]) {
            scope.modelCleaned = true;
          }
        }
      });
    },
    controller: 'DefaultExternalComboWidgetCtrl'
  };
}]);
angular.module('backstage.directives.externals').directive('bsSpeakersSelectorComboWidget', [function () {
  return {
    templateUrl: '/static/partials/components/default-external-combo-widget.html',
    require: '?ngModel',
    priority: 100,
    scope: {
      model: '=ngModel',
      fieldDescriptor: '=',
      field: '=',
      label: '=',
      hideLabel: '=',
      hideCreateButton: '=',
      disableOptionsRemove: '=',
      options: '=',
      showAddButtonInHeader: '='
    },
    link: function link() {
      return console.warn('DEPRECATED. bs-speakers-selector-combo-widget is deprecated, ' + 'use bs-external-default-combo-widget instead');
    },
    controller: 'DefaultExternalComboWidgetCtrl'
  };
}]);
angular.module('backstage.directives.externals').controller('DefaultExternalComboWidgetCtrl', /* @ngInject */["$log", "$q", "$scope", "$rootScope", "$filter", "userService", "urlService", "eventService", "metadataService", "backlinksService", "bulkUpdateService", "essenceManager", "$timeout", "$element", function ($log, $q, $scope, $rootScope, $filter, userService, urlService, eventService, metadataService, backlinksService, bulkUpdateService, essenceManager, $timeout, $element) {
  var _collectionWatchCb2, legacyModeDetectionPromise;
  var LABEL_SEARCH_MINIMUM_INPUT_LENGTH = 0;
  var LEGACY_SEARCH_MINIMUM_RESULTS_FOR_SEARCH_BOX = 5;
  var CREATE_NEW_ITEM_SPECIAL_KEY = $scope.CREATE_NEW_ITEM_SPECIAL_KEY = '__CREATE_NEW__';
  var options = $scope.options || {};
  $scope.backlinksService = backlinksService;
  $scope.fetchAndMapItems = fetchAndMapItems;
  extend($scope, options);
  $scope.idField = options.id_field;
  var idField = $scope.idField || 'fp_ext_id';
  $scope.fpExtIdToAdd = {};
  $scope.displaySubtypes = $scope.subtypes || [$scope.type];
  var cachedSortedItemList = $scope.cachedSortedItemList = [];
  var cachedIdToNameMappings = $scope.cachedIdToNameMappings = {};
  var cachedIdToStatusMappings = {};
  var cachedIdToAssetMappings = {};
  var event = eventService.getCurrentEvent();
  var eventId = $scope.eventId = event._id;
  var eventNode = event.node;
  var metadataForType = metadataService.getCachedMetadataForType(eventId, $scope.type);
  var metadataFieldsForNewItem = $scope.metadataFieldsForNewItem = [];
  var metadataForTypeArray = metadataService.getCachedMetadataForTypeAsArray(eventId, $scope.type);
  var isInvitedByLink = userService.isInvitedByLink(event);
  $scope.isInvitedByLink = isInvitedByLink;

  // filter out fields hidden for users invited by accredited link without proper event role
  if (isInvitedByLink) {
    var forbiddenFieldTypes = ['external', 'nested-object', 'list', 'custom'];
    metadataForTypeArray = metadataForTypeArray.filter(function (field) {
      return !(0, _lodash.get)(field, 'hideForInvited') && !((0, _lodash.get)(field, 'is_custom_field') && forbiddenFieldTypes.includes((0, _lodash.get)(field, 'kind')));
    });
  }
  var watchedCollection = [];
  $scope.isSaving = false;
  $scope.isInLegacyModeDetermined = false;
  $scope.getIdsArrayForSubType = getIdsArrayForSubType;
  $scope.getHumanizedType = getHumanizedType;
  $scope.editFields = metadataForTypeArray;
  if ($scope.isBulkEdit && !$scope.single_doc) {
    // if we are in bulk edit mode, and the external selector is not a single select...
    $scope.bulkFieldOptions[$scope.field] = 'add-to-existing';
  }
  $scope.getItemCreationVerb = function () {
    if (options.item_creation_verb) return options.item_creation_verb;
    return $scope.formEssence && $scope.formEssence.itemCreationVerb ? $scope.formEssence.itemCreationVerb : 'Create';
  };
  $scope.getHumanizedTypeCountTooltipText = function () {
    if (!isEmpty(cachedSortedItemList)) {
      var count = cachedSortedItemList.length;
      var pluralSuffix = count > 1 ? 's' : '';
      return "".concat(count, " ").concat(getHumanizedType()).concat(pluralSuffix, " available");
    }
  };
  $scope.canAddAnItem = function (subtype) {
    var idsArrayLength = (getIdsArrayForSubType(subtype) || []).length;
    if ($scope.options.maxNumber && idsArrayLength >= $scope.options.maxNumber) {
      return false;
    }
    return !$scope.single_doc || !idsArrayLength;
  };
  $scope.canCreateAnItem = function () {
    return metadataForTypeArray && metadataForTypeArray.length > 0;
  };
  $scope.getHeadingRowTextForType = function (subtype) {
    if ($scope.subtypes) {
      return subtype;
    }
    return $scope.label || (metadataForType[$scope.field] || {}).label || $scope.field;
  };
  $scope.getIdForDoc = function (doc) {
    return doc[idField] || doc._id;
  };
  $scope.getDisplayNameForId = function (fpExtId) {
    return cachedIdToNameMappings[fpExtId] || $scope.fpExtIdMap && $scope.fpExtIdMap[fpExtId] || fpExtId;
  };
  $scope.getCrudHyperlinkForId = function (fpType, fpExtId) {
    if (!urlService.isValidAppRoute("/event/:eventId/".concat(fpType, "s/:modelId"))) {
      return null;
    }
    var _id = (findWhere(cachedSortedItemList, _defineProperty({}, idField, fpExtId)) || {})._id;
    if (!_id) {
      return '';
    }
    return "/event/".concat(eventId, "/").concat(fpType, "s/").concat(_id);
  };
  var imageFormats = ['jpg', 'jpeg', 'png', 'gif'];
  $scope.getAssetUrlForId = function (fpExtId) {
    var asset = cachedIdToAssetMappings[fpExtId];
    if (!asset) {
      return;
    }
    if (imageFormats.indexOf(last(asset.split('.'))) === -1) {
      return;
    }
    return "/api/v1/events/".concat(eventId, "/assets/").concat(asset);
  };
  $scope.getIconClassForType = function () {
    switch ($scope.type) {
      case 'person':
      case 'presenter':
        return 'icon-user';
      case 'session':
        return 'icon-calendar';
      default:
        return 'icon-link';
    }
  };
  $scope.getVisibilityClassesForId = function (fpExtId) {
    switch (cachedIdToStatusMappings[fpExtId]) {
      case 'cancelled':
        return 'translucent';
      case 'hidden':
        return 'translucent';
      default:
        return '';
    }
  };
  $scope.revealAddDropdownControls = function () {
    if ($scope.isInLegacyMode && !(cachedSortedItemList ? cachedSortedItemList.length : undefined)) {
      // if the list is empty we'll try to fetch again
      // (this is particularly useful when the user has just created a new item in a new tab/window and wants to see the list refresh)
      $scope.loading = true;
      eventService.getEventDocsByType(event, $scope.type).then(legacyGetEventDocsByTypeCb);
    }
    $scope.showAddControls = true;
    $timeout(function () {
      $element.find('.btn-add-item').select2('open');
    }, 250);
  };
  $scope.openCreateNewItemModal = function (fpType, subtype) {
    // special types that require the normal create page, because it's custom
    if (fpType === 'live_stream') {
      return window.open("/event/".concat(eventId, "/live_streams/new"), '_blank');
    }
    if (fpType === 'content-video' || fpType === 'content-document') {
      var scope = options.scope || '';
      var defaultMimes = fpType === 'content-video' ? ['video/mp4'] : ['application/pdf'];
      var acceptedMimes = options.accepted_mimes || defaultMimes;
      var context = options.context || {};
      var detail = {
        scope: scope,
        context: context,
        acceptedMimes: acceptedMimes
      };
      var _event = new CustomEvent('start-uploader', {
        detail: detail
      });
      window.dispatchEvent(_event);
      return;
    }
    $scope.newItemCreationParams = {
      type: fpType,
      subtype: subtype,
      metadata: metadataForTypeArray
    };
    var _defaults = metadataService.extractDefaults(metadataForTypeArray);
    $scope.newItemFpType = fpType;
    $scope.newItemModel = extend({}, _defaults, {
      fp_type: fpType
    });
    $scope.showAddControls = false;
    $rootScope.setNavigationWarningMessage(null);
    angular.copy(metadataForTypeArray, metadataFieldsForNewItem);
    $scope.previousCachedSortedItemList = (0, _lodash.cloneDeep)(cachedSortedItemList);
    angular.copy([], cachedSortedItemList); // to empty the existing item list
  };

  $scope.closeCreateNewItemModal = function () {
    angular.copy($scope.previousCachedSortedItemList, cachedSortedItemList);
    $scope.newItemCreationParams.type = null;
    $scope.isSaving = false;
    watchedCollection = [];
    ($scope.displaySubtypes || []).forEach(function (subType) {
      getIdsArrayForSubType(subType, true);
    });
  };
  $scope.submit = function (saveModel) {
    var _arguments = arguments,
      _this = this;
    var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $scope.newItemModel;
    var form = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var subtype = $scope.newItemCreationParams.subtype;
    if (!saveModel || form.$invalid) {
      return;
    }
    if ($scope.formEssence.name === 'asset') {
      // assets have already been on a trip to the server so we must override their inherent attributes
      extend(model, $scope.newItemModel);
    }
    $scope.isSaving = true;
    return $scope.formEssence.save(model, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(model, fpType) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return saveModel(model, fpType, true);
            case 2:
              result = _context.sent;
              if (!result.error) {
                _context.next = 5;
                break;
              }
              throw result.error;
            case 5:
              if (!$scope.isInLegacyMode) {
                _context.next = 12;
                break;
              }
              $scope.loading = true;
              _context.next = 9;
              return eventService.getEventDocsByType(event, $scope.type, {
                cached: true
              });
            case 9:
              return _context.abrupt("return", legacyGetEventDocsByTypeCb.apply(_this, _arguments));
            case 12:
              return _context.abrupt("return", backlinksService.triggerAndWaitForBacklinksRefresh(eventId));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()).then(function () {
      $scope.addFpExtIdAsSubType(subtype, model[idField]);
    }).then(function () {
      $scope.newItemCreationParams.type = null; // this hides the modal
    }).catch(function () {
      $scope.removeFpExtIdFromSubType(subtype, model[idField]);
    }).finally(function () {
      $scope.isSaving = false;
    });
  };
  $scope.addFpExtIdAsSubType = function (subtype, fpExtId) {
    var ids = getIdsArrayForSubType(subtype, true);
    if (!isString(fpExtId)) {
      return;
    }
    // are we creating a new item via the shortcut dropdown item?
    if (fpExtId === CREATE_NEW_ITEM_SPECIAL_KEY) {
      return $scope.openCreateNewItemModal($scope.type, subtype);
    }
    if (Array.from(ids).includes(fpExtId)) {
      return $rootScope.setNavigationWarningMessage(null);
    }
    if ($scope.single_doc) {
      $scope.model[$scope.field] = fpExtId;
    } else {
      ids.push(fpExtId);
    }
  };
  $scope.removeFpExtIdFromSubType = function (subtype, fpExtId) {
    var model = $scope.model,
      field = $scope.field;
    var ids = getIdsArrayForSubType(subtype, true);
    var idx = ids.indexOf(fpExtId);
    if (!ids || idx === -1) {
      return;
    }
    if ($scope.single_doc) {
      model[field] = null;
    } else {
      ids.splice(idx, 1);
    }
  };
  $scope.pullItemUp = function (subtype, fpExtId) {
    var ids = getIdsArrayForSubType(subtype, true);
    var idx = ids.indexOf(fpExtId);
    if (idx === 0) {
      return;
    }
    ids.splice(idx - 1, 0, ids.splice(idx, 1)[0]);
  };
  $scope.pushItemDown = function (subtype, fpExtId) {
    var ids = getIdsArrayForSubType(subtype, true);
    var idx = ids.indexOf(fpExtId);
    if (idx === ids.length - 1) {
      return;
    }
    ids.splice(idx + 1, 0, ids.splice(idx, 1)[0]);
  };
  $scope.navigate = function () {
    if ($rootScope.navigationWarningMessage && !confirm('You will lose any unsaved data on this page upon navigating away. Proceed?')) {
      return;
    }
    return $rootScope.navigate.apply($scope, arguments);
  };
  init();

  /** *********** */
  /* FUNCTIONS  */
  /** *********** */

  function getHumanizedType() {
    return $filter('humanize')($scope.type);
  }
  function legacyGetEventDocsByTypeCb(evDocsListData) {
    var _list = (evDocsListData || {}).data;
    if (_list) {
      return fetchAndMapItems(_list);
    }
  }
  function getIdsArrayForSubType(subtype, createDefault) {
    var model = $scope.model,
      field = $scope.field;
    if (!model || !field) {
      return [];
    }
    if (createDefault) {
      // set the default field value
      // if single_doc then this is an empty string
      // if we have subtypes it's an empty object
      // or we'll set an empty array (to be filled with fp_ext_ids)

      var defaultFieldValue;
      if ($scope.single_doc) {
        defaultFieldValue = '';
      } else if ($scope.subtypes) {
        defaultFieldValue = {};
      } else {
        defaultFieldValue = [];
      }
      if (!model[field]) {
        model[field] = defaultFieldValue;
      }
    }

    // now return the array of ids that we'll use to render the list
    if ($scope.single_doc) {
      if (isEmpty(model[field])) {
        return [];
      }
      watchedCollection = flatten([model[field]]);
    } else if ($scope.subtypes) {
      // initialize default value if needed
      if (model[field]) {
        if (!model[field][subtype] && createDefault) {
          model[field][subtype] = [];
        }
      }
      watchedCollection = (model[field] || {})[subtype] || [];
    } else {
      if (!isEmpty(model[field]) && !isArray(model[field])) {
        model[field] = [model[field]];
      }
      watchedCollection = model[field] || [];
    }
    if (!isArray(watchedCollection)) {
      console.warn("Wrong value for field ".concat(field, ": ").concat(watchedCollection, ". It should be an array."));
      watchedCollection = [];
    }
    return watchedCollection;
  }
  function triggerLegacyModeFetchAndMapItems() {
    $scope.loading = true;
    return eventService.getEventDocsByType(event, $scope.type, {
      cached: true
    }).then(legacyGetEventDocsByTypeCb);
  }
  if ($scope.isInLegacyModeDetermined) {
    if ($scope.isInLegacyMode) {
      triggerLegacyModeFetchAndMapItems();
    }
  } else {
    legacyModeDetectionPromise.then(function () {
      if ($scope.isInLegacyMode) {
        return triggerLegacyModeFetchAndMapItems();
      }
    });
  }
  function init() {
    if ($scope.subtypes) {
      // backlinks not available when using subtypes
      $scope.isInLegacyMode = true;
      $scope.isInLegacyModeDetermined = true;
    } else {
      legacyModeDetectionPromise = backlinksService.isBacklinksSearchAvailable(eventId, eventNode).then(function (isBacklinksSearchAvailable) {
        $scope.isInLegacyModeDetermined = true;
        $scope.isInLegacyMode = !isBacklinksSearchAvailable;
        if ($scope.isInLegacyMode) {
          return $scope.select2Options = {
            placeholder: 'Choose an item',
            minimumResultsForSearch: LEGACY_SEARCH_MINIMUM_RESULTS_FOR_SEARCH_BOX
          };
        }
        // go remote
        var handlerUrl = backlinksService.getSearchHandlerUrl(eventId, $scope.type);
        return $scope.select2Options = {
          placeholder: 'Find an item',
          minimumInputLength: LABEL_SEARCH_MINIMUM_INPUT_LENGTH,
          minimumResultsForSearch: LEGACY_SEARCH_MINIMUM_RESULTS_FOR_SEARCH_BOX,
          ajax: {
            url: handlerUrl,
            dataType: 'json',
            quietMillis: 250,
            data: function data() {
              var term = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
              return {
                query: term.length ? term : ' ',
                field: idField
              };
            },
            results: function results() {
              var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              var field = $scope.model[$scope.field];
              if (field) {
                var ids = field;
                if (isObject(field[0])) {
                  ids = field.map(function (o) {
                    return o.id || o._id || o.fp_ext_id;
                  });
                }
                list = list.filter(function (i) {
                  return !ids.includes(i.id || i._id || i.fp_ext_id);
                });
              }
              return {
                results: list
              };
            },
            cache: false
          }
        };
      }).catch(function () {
        // fall back to legacy mode on error
        $scope.isInLegacyMode = true;
        $scope.isInLegacyModeDetermined = true;
      });
    }
    essenceManager.addEssenceToForm(metadataForType._essence, metadataForTypeArray, $scope.type).then(function (formEssence) {
      $scope.formEssence = formEssence;
    });
    $scope.$watchCollection(function () {
      return watchedCollection;
    }, _collectionWatchCb2 = function collectionWatchCb(collection) {
      if (!(collection ? collection.length : undefined)) {
        return;
      }

      // if we don't know if we're in legacy mode wait until we do know
      if (!$scope.isInLegacyModeDetermined) {
        var _collectionWatchCb = partial(_collectionWatchCb2, collection);
        return legacyModeDetectionPromise.then(_collectionWatchCb, _collectionWatchCb);
      }
      if (!$scope.isInLegacyMode) {
        $scope.loading = true;
        backlinksService.queryBacklinksWithKeys(eventId, $scope.type, idField, collection).then(function (list) {
          $scope.loading = false;
          return fetchAndMapItems(list);
        });
      }
    });
  }
  function fetchAndMapItems(docsList) {
    // ⚑ UNAVOIDABLE HACK ALERT
    // TODO: REMOVE this when we have fully transitioned away from hosted_docs
    docsList = docsList.map(function (_doc) {
      var ext, props;
      if (!_doc._id || _doc.fp_type !== 'hosted_doc') {
        return _doc;
      }
      if (!(props = _doc.bs_fileprops) || !(ext = props.extension)) {
        return _doc;
      }
      if (_doc._id.substring(_doc._id.length - (ext.length + 1)) === ".".concat(ext)) {
        return _doc;
      }
      _doc._id = "".concat(_doc._id, ".").concat(ext);
      return _doc;
    });
    var idToNameMappings = docsList.reduce(function (memo, doc) {
      var reprLabel = metadataService.getReprLabelForItem(eventId, doc);
      var fallbackLabel = function () {
        switch ($scope.type) {
          case 'person':
            return doc.fullname || "".concat(doc.fname, " ").concat(doc.lname);
          default:
            return doc.name && doc.name.en || doc.name || doc.title || doc.subject || doc.label || doc.fp_ext_id || doc._id;
        }
      }();
      memo[doc[idField]] = reprLabel || fallbackLabel;
      return memo;
    }, {});
    angular.extend(cachedIdToNameMappings, idToNameMappings);
    var idToStatusMappings = docsList.reduce(function (memo, doc) {
      if (doc.fp_status) {
        memo[doc[idField]] = doc.fp_status;
      }
      return memo;
    }, {});
    angular.extend(cachedIdToStatusMappings, idToStatusMappings);
    var filteredSortedItemList = $filter('filterOutPaxWithFpStatusCancelled')(sortBy(docsList, 'fname', 'title'));
    angular.copy(filteredSortedItemList, cachedSortedItemList);
    var idToAssetMappings = docsList.reduce(function (memo, doc) {
      if (doc.fp_asset) {
        memo[doc[idField]] = doc.fp_asset;
      }
      return memo;
    }, {});
    angular.extend(cachedIdToAssetMappings, idToAssetMappings);
    return $scope.loading = false;
  }
  if ($scope.canCreateAnItem()) {
    cachedIdToNameMappings[CREATE_NEW_ITEM_SPECIAL_KEY] = 'Create a new item';
    $scope.isCreateNewItemRouteAvailable = true;
  }
  $scope.openEditItemModal = function (fpExtId) {
    return backlinksService.queryBacklinksWithKeys(eventId, $scope.type, idField, [fpExtId]).then(function (result) {
      var doc = result[0];
      if ($scope.type === 'person') {
        return eventService.getEventParticipantInfoAndTimeline(event, doc._id).then(function (result) {
          return result.data;
        });
      } else {
        return doc;
      }
    }).then(function (doc) {
      $scope.editModel = doc;
      $scope.showEditModal = true;
    });
  };
  $scope.saveUpdatedModel = function (model) {
    var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (form.$invalid) {
      return;
    }
    $scope.isSavingEdit = true;
    return bulkUpdateService.updateDoc(eventId, eventNode, model.fp_type, model).then(function () {
      $rootScope.setFlashMessage('This item has been saved.');
      return backlinksService.triggerAndWaitForBacklinksRefresh(eventId);
    }).then(function () {
      _collectionWatchCb2(watchedCollection);
      $scope.closeEditItemModal();
    }).catch(function (err) {
      $log.error('Could not save the doc', err);
      $rootScope.setFlashMessage('An error occurred. The item was not saved.', 'danger');
    }).finally(function () {
      $scope.isSavingEdit = false;
    });
  };
  $scope.closeEditItemModal = function () {
    $scope.showEditModal = false;
  };
  $scope.getTooltip = function (fpExtId) {
    if ($scope.type === 'icon' && idField === 'fp_asset' && !hasIconCorrectFormat(fpExtId)) {
      return $scope.formEssence.getRepresentation("".concat(fpExtId, "/file.png")).tooltip;
    }
    return $scope.formEssence.getRepresentation(fpExtId).tooltip;
  };
}]);